import { NavigateOptions, URLSearchParamsInit, useSearchParams } from 'react-router-dom';
import 'core-js/features/object/from-entries';

export type SetURLSearchParams = (
	nextInit?: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
	navigateOpts?: NavigateOptions,
) => void;

export const useCustomSearchParams = (
	defaultUrl?: string,
): [{ [k: string]: any }, SetURLSearchParams] => {
	let url: URL | undefined;
	if (defaultUrl) {
		url = new URL(defaultUrl ?? '');
	}
	const [search, setSearch] = useSearchParams();
	const searchAsObject = Object.fromEntries(new URLSearchParams(url?.search ?? search));

	return [searchAsObject, setSearch];
};
